<template>
  <div id="app" class="h-screen overflow-x-hidden">
    <vue-internet-checker @status="status" />
    <div name="navbar" v-if="$route.path != '/login'">
      <Navbar />
    </div>

    <router-view @loggedIn="goToMainPage()" />
    <!-- </transition> -->
    <div id="modalLocation"></div>
    <Loader v-if="this.loading" />
    <slot v-else></slot>
  </div>
</template>

<script>
import router from "./router";
import store from "./store";
import Loader from "./components/Loader.vue";
import $ from "jquery";
import Vue from "vue";
import { mapState } from "vuex";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import vueInternetChecker from "vue-internet-checker";
import Navbar from "./components/Navbar.vue";
Vue.use(Toast, {
  // registration props here
  position: "top-center",
});
export default {
  data() {
    return {
      online: null,
      ali: store.state.loader.loading,
      selectedImageID: null,
      // loading: false,
    };
  },
  components: {
    Navbar,
    Loader,
    vueInternetChecker,
  },
  computed: {
    ...mapState("loader", ["loading"]),
  },
  created() {
    if (this.$store.state.id) {
      if (this.$route.path == "/main-page") {
        // TODO Check
        router.replace({ path: "/projects" });
      }
    } else {
      if (this.$route.path != "/login") {
        // TODO Check
        router.replace({ path: "/login" });
      }
    }

    if (
      this.$store.state.userType.id == 1 ||
      this.$store.state.userType.id == 4
    ) {
      if (this.$route.path == "/") {
        router.push("projects");
      }
    }

    // Clear pending requests and turn off loadder on refresh
    this.$store.state.loader.loading = false;
    this.$store.state.loader.requestsPending = 0;
  },
  methods: {
    status(ele) {
      console.log(ele);
      this.online = ele;
      if (this.online) {
        this.$toast.success("Internet connection was restored");
      } else {
        this.$toast.error("You are currently offline");
      }
    },

    goToMainPage() {
      if (this.$route.path != "/projects") {
        router.push("projects");
      }
    },
    hideOverflow(hide) {
      document.getElementById("app").style.overflow = hide ? "hidden" : "auto";
    },
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
<style scoped>
body {
  font-size: 0.9rem;
}
</style>
